import React from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { Delete as DeleteIcon } from '@material-ui/icons';
import { toast } from 'react-toastify';

import NumberColor from '../../../Components/NumberColor';
import DeleteButtom from '../../../Components/DeleteButton';
import TextArea from '../../../Components/TextArea';
import InputRow from '../../../Components/InputRow';

import FITTypes from '../../../StaticData/FITTypes';
import CURRENCIES from '../../../StaticData/Currencies';
import VISATYPES from '../../../StaticData/VISATypes';

import ThingsToSelect from '../../../Helper/ThingsToSelect';
import APIGet from '../../../API/APIGet';
import APIHelper from '../../../Helper/APIHelper';
import TravelerHelper from '../../../Helper/Traveler';

import FITItemTicket from './FITItemTicket';
import FITItemVisa from './FITItemVisa';

export default class FITItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			fitSuppliers: props.fitSuppliers ? props.fitSuppliers : [],
			countryOptions: [],
		};
	}

	onDetailChange = (key, value) => {
		this.props.onDetailChange(this.props.index, key, value);
	};

	addDetail = () => {
		this.props.addDetail(this.props.index);
	};

	removeDetail = index => {
		this.props.removeDetail(this.props.index, index);
	};

	onDetailArrayChange = (index, key, value) => {
		this.props.onDetailArrayChange(this.props.index, index, key, value);
	};

	renderFitItem = () => {
		const {
			selectedFitType,
			fitTicket,
			fitVisa,
			fitHotel,
			fitCarRental,
			fitInsurrance,
			fitTravelTicket,
			fitPocketWifiSim,
			fitTranslation,
			airlines,
			initTravelers,
		} = this.props;
		if (!selectedFitType) {
			return null;
		}
		if (selectedFitType.value === 'fitTicket') {
			return (
				<FITItemTicket
					{...fitTicket}
					fitTicket={fitTicket}
					initTravelers={initTravelers}
					airlines={airlines}
					onChange={this.onDetailChange}
					onAdd={this.addDetail}
					onRemove={this.removeDetail}
					onPassengerChange={this.onDetailArrayChange}
				/>
			);
		} else {
			let fitDetails = [];
			if (selectedFitType.value === 'fitVisa') {
				fitDetails = fitVisa.details;
				// console.log('fitVisa.travelers: ', fitVisa);
			} else if (selectedFitType.value === 'fitHotel') {
				fitDetails = fitHotel.details;
			} else if (selectedFitType.value === 'fitCarRental') {
				fitDetails = fitCarRental.details;
			} else if (selectedFitType.value === 'fitInsurrance') {
				fitDetails = fitInsurrance.details;
			} else if (selectedFitType.value === 'fitTravelTicket') {
				fitDetails = fitTravelTicket.details;
			} else if (selectedFitType.value === 'fitPocketWifiSim') {
				fitDetails = fitPocketWifiSim.details;
			} else if (selectedFitType.value === 'fitTranslation') {
				fitDetails = fitTranslation.details;
			}

			return (
				<FITItemVisa
					fitType={selectedFitType.value}
					fitDetails={fitDetails}
					amount={fitVisa && fitVisa.amount}
					onChange={this.onDetailArrayChange}
					onAdd={this.addDetail}
					onRemove={this.removeDetail}
				/>
			);
		}
	};

	onFitTypeChange = value => {
		const fitSuppliers = ThingsToSelect(this.props.fitSuppliersRaw.filter(supplier => supplier.fitType === value.value));
		this.props.onFitChange(this.props.index, 'selectedFitType', value);
		this.setState({
			fitSuppliers,
		});
	};

	onSupplierChange = value => {
		this.props.onFitChange(this.props.index, 'selectedSupplier', value);
	};

	onCreditCardCurrencyChange = value => {
		this.props.onFitChange(this.props.index, 'selectedCreditCardCurrency', value);
	};

	onCreditCardChange = value => {
		this.props.onFitChange(this.props.index, 'selectedCreditCard', value);
	};

	onCountryChange = value => {
		this.props.onFitChange(this.props.index, 'selectedCountry', value);
		this.props.onDetailChange(this.props.index, 'countryId', value.value);
	};

	onVisaTypeChange = value => {
		this.props.onFitChange(this.props.index, 'selectedVisaType', value);
		this.props.onDetailChange(this.props.index, 'visaType', value.value);
	};

	onTextChange = (key, value) => {
		this.props.onFitChange(this.props.index, key, value);
	};

	onVisaAmountChange = (key, value) => {
		this.props.onDetailChange(this.props.index, key, value);
	};

	remove = () => {
		this.props.onRemove(this.props.index);
	};

	removeTraveler = id => {
		const { selectedFitType } = this.props;
		// console.log('selectedFitType: ', selectedFitType);
		const fitKey = selectedFitType && selectedFitType.value ? selectedFitType.value : null; // 'fitVisa' | 'fitHotel' | ...
		if (!fitKey || !this.props[fitKey]) return;

		const targetId = Number(id);
		const fit = this.props[fitKey];
		// console.log('fit: ', fit);
		const travelers = fit && Array.isArray(fit.travelers) ? fit.travelers : [];

		const filteredTravelers = travelers.filter(t => {
			const travelerId = t && (t.id != null ? t.id : t.travelerId);
			return Number(travelerId) !== targetId;
		});

		// console.log(filteredTravelers);
		let travelerIds = [];
		if (filteredTravelers && filteredTravelers.length > 0) {
			travelerIds = filteredTravelers.map(t => t.id).filter(id => id != null && !Number.isNaN(id));
		}

		this.props.onDetailChange(this.props.index, 'travelers', filteredTravelers);
		this.props.onDetailChange(this.props.index, 'travelerIds', travelerIds);
	};

	getCurrentFitTravelers = () => {
		const { selectedFitType } = this.props;
		const fitKey = selectedFitType && selectedFitType.value ? selectedFitType.value : null;
		if (!fitKey || !this.props[fitKey]) return [];
		const fit = this.props[fitKey];
		return fit && Array.isArray(fit.travelers) ? fit.travelers : [];
	};

	getDefaultTravelerOptions = () => {
		const { initTravelers } = this.props;
		const currentTravelers = this.getCurrentFitTravelers();
		const existingTravelerIds = new Set((currentTravelers || []).map(t => Number(t.id)));
		return (initTravelers || [])
			.filter(t => t && !existingTravelerIds.has(Number(t.id)))
			.map(t => ({
				value: t.id,
				label: TravelerHelper.getNameAndContact(t),
				travelerRecord: t,
			}));
	};

	loadTravelerOptions = async inputValue => {
		const q = (inputValue || '').trim();
		if (!q) return this.getDefaultTravelerOptions();

		const request = await APIGet('travelers?page=1&perPage=40&filter=' + q);
		if (!APIHelper.handleAPIResponse(this, request)) {
			toast.error('ไม่สามารถดึงข้อมูล Traveler ได้ กรุณาลองใหม่อีกครั้ง');
			return [];
		}

		const responseData = request.data;
		const apiTravelers = Array.isArray(responseData) ? responseData : responseData.data || [];
		const currentTravelers = this.getCurrentFitTravelers();
		const existingTravelerIds = new Set((currentTravelers || []).map(t => Number(t.id)));
		return apiTravelers
			.filter(t => t && !existingTravelerIds.has(Number(t.id)))
			.map(t => ({
				value: t.id,
				label: TravelerHelper.getNameAndContact(t),
				travelerRecord: t,
			}));
	};

	addTraveler = travelerInput => {
		const { selectedFitType } = this.props;
		if (!travelerInput) return;
		const id = travelerInput.value != null ? travelerInput.value : travelerInput.id;
		const fitKey = selectedFitType && selectedFitType.value ? selectedFitType.value : null; // 'fitVisa' | 'fitHotel' | ...
		if (!fitKey || !this.props[fitKey]) return;

		const fit = this.props[fitKey];
		const travelers = fit && Array.isArray(fit.travelers) ? fit.travelers : [];
		const travelerIds = fit && Array.isArray(fit.travelerIds) ? fit.travelerIds : [];
		const isAlreadyAdded = travelerIds.includes(Number(id));
		if (isAlreadyAdded) {
			toast.warn('Traveler นี้ถูกเพิ่มไปแล้ว');
			return;
		}

		// Full row comes from the option we built in getDefaultTravelerOptions / loadTravelerOptions (not initTravelers lookup).
		const traveler = travelerInput.travelerRecord;
		const firstName = traveler ? traveler.firstName || traveler.first_name || '' : travelerInput.firstName || '';
		const lastName = traveler ? traveler.lastName || traveler.last_name || '' : travelerInput.lastName || '';
		const middleName = traveler ? traveler.middleName || traveler.middle_name || '' : travelerInput.middleName || '';
		const row = { id: Number(id), firstName, middleName, lastName };
		if (traveler) {
			const thaiFirstName = traveler.thaiFirstName || traveler.thai_first_name || '';
			const thaiMiddleName = traveler.thaiMiddleName || traveler.thai_middle_name || '';
			const thaiLastName = traveler.thaiLastName || traveler.thai_last_name || '';
			if (thaiFirstName || thaiMiddleName || thaiLastName) {
				row.thaiFirstName = thaiFirstName;
				row.thaiMiddleName = thaiMiddleName;
				row.thaiLastName = thaiLastName;
			}
		}
		if (traveler && traveler.traveler && typeof traveler.traveler === 'object') {
			row.traveler = traveler.traveler;
		}
		if (!TravelerHelper.getFullName(row) && travelerInput.label) {
			const label = String(travelerInput.label);
			row.name = label.replace(/\s*\([^)]*\)\s*$/, '').trim() || label;
		}
		travelers.push(row);
		travelerIds.push(Number(id));
		this.props.onDetailChange(this.props.index, 'travelers', travelers);
		this.props.onDetailChange(this.props.index, 'travelerIds', travelerIds);
		this.setState({ selectedTraveler: null });
	};

	renderTravelers = fitTravelers => {
		const rowStyle = {
			display: 'flex',
			alignItems: 'flex-start',
			gap: 4,
		};
		const nameTextStyle = {
			flex: 1,
			minWidth: 0,
			lineHeight: 1.2,
			...TravelerHelper.fullNameStyle,
			overflowWrap: 'anywhere',
			wordBreak: 'break-word',
			paddingRight: '4px',
		};
		return (
			<div className="columns is-multiline" style={{ marginTop: 6 }}>
				{fitTravelers.map(traveler => (
					<div className="column is-3" key={'traveler' + traveler.id} style={{ paddingTop: 8, paddingBottom: 8 }}>
						<div style={rowStyle}>
							<div style={nameTextStyle}>{TravelerHelper.getFullName(traveler)}</div>
							<button
								type="button"
								className="button is-small is-text"
								style={{ flexShrink: 0, minWidth: 'auto', color: '#f14668' }}
								onClick={() => this.removeTraveler(traveler.id)}
							>
								<DeleteIcon style={{ fontSize: 20 }} />
							</button>
						</div>
					</div>
				))}
			</div>
		);
	};

	render() {
		const {
			totalPrice,
			selectedFitType,
			selectedSupplier,
			note,
			creditCardRecord,
			selectedCreditCardCurrency,
			selectedCreditCard,
			creditCharge,
			creditCards,
			fitVisa,
			fitHotel,
			fitCarRental,
			fitInsurrance,
			fitTravelTicket,
			fitPocketWifiSim,
			fitTranslation,
			initCountries,
			selectedCountry,
			selectedVisaType,
		} = this.props;
		const { fitSuppliers } = this.state;
		const getTravelerLabel = option => {
			if (!option) return '';
			return option.label;
		};

		const getTravelers = fit => (fit && Array.isArray(fit.travelers) ? fit.travelers : []);

		const creditCardOptions = (Array.isArray(creditCards) ? creditCards : []).filter(o => o != null);

		let fitTravelersToRender = [];
		if (selectedFitType) {
			if (selectedFitType.value === 'fitVisa') fitTravelersToRender = getTravelers(fitVisa);
			else if (selectedFitType.value === 'fitHotel') fitTravelersToRender = getTravelers(fitHotel);
			else if (selectedFitType.value === 'fitCarRental') fitTravelersToRender = getTravelers(fitCarRental);
			else if (selectedFitType.value === 'fitInsurrance') fitTravelersToRender = getTravelers(fitInsurrance);
			else if (selectedFitType.value === 'fitTravelTicket') fitTravelersToRender = getTravelers(fitTravelTicket);
			else if (selectedFitType.value === 'fitPocketWifiSim') fitTravelersToRender = getTravelers(fitPocketWifiSim);
			else if (selectedFitType.value === 'fitTranslation') fitTravelersToRender = getTravelers(fitTranslation);
		}
		return (
			<div className="box">
				<div className="columns">
					<div className="column is-3" style={{ textAlign: 'left' }}>
						ราคาขาย
						<h4 className="title is-4">
							<NumberColor number={totalPrice.salePrice + totalPrice.creditCharge} /> THB
						</h4>
						{totalPrice.creditCharge > 0 ? (
							<span>
								(รวม credit charge: <NumberColor number={totalPrice.creditCharge} /> THB)
							</span>
						) : null}
					</div>
					<div className="column is-3" style={{ textAlign: 'left' }}>
						ต้นทุน
						<h4 className="title is-4">
							<NumberColor number={totalPrice.price} /> THB
						</h4>
					</div>
					<div className="column is-3" style={{ textAlign: 'left' }}>
						กำไร
						<h4 className="title is-4">
							<NumberColor number={totalPrice.salePrice - totalPrice.price} /> THB
						</h4>
					</div>
					<div className="column is-3" style={{ textAlign: 'right' }}>
						<DeleteButtom label="ลบ" warningMessage="ยืนยันการลบ" onClick={this.remove} />
					</div>
				</div>
				<div className="columns">
					<div className="column is-2">
						<label className="label">Service (บริการ)</label>
						<Select name="fitType" value={selectedFitType} clearable={false} onChange={this.onFitTypeChange} options={FITTypes} />
					</div>
					<div className="column is-2">
						<label className="label">Supplier</label>
						<Select name="supplier" value={selectedSupplier} clearable={false} onChange={this.onSupplierChange} options={fitSuppliers} />
					</div>

					<div className="column is-2">
						<InputRow
							title="Credit Charge (%)"
							labelSize="s"
							placeholder="Credit Charge (%)"
							keyProps="creditCharge"
							type="number"
							min={0}
							max={100}
							step={0.01}
							value={creditCharge}
							onInputChange={this.onTextChange}
							disabled={false}
						/>
					</div>
					<div className="column is-2">
						<InputRow
							title="ยอดที่ตัดบัตร"
							labelSize="s"
							placeholder="ยอดที่ตัดบัตร"
							keyProps="creditCardRecord"
							type="number"
							min={0}
							step={0.01}
							value={creditCardRecord}
							onInputChange={this.onTextChange}
							disabled={false}
						/>
					</div>
					<div className="column is-2">
						<label className="label">สกุลเงิน</label>
						<Select
							name="fitType"
							value={selectedCreditCardCurrency}
							clearable={false}
							onChange={this.onCreditCardCurrencyChange}
							options={CURRENCIES}
						/>
					</div>
					<div className="column is-2">
						<label className="label">Credit Card</label>
						<Select
							name="selectedCreditCard"
							value={selectedCreditCard}
							clearable={false}
							onChange={this.onCreditCardChange}
							options={creditCardOptions}
						/>
					</div>
				</div>
				{selectedFitType && selectedFitType.value === 'fitVisa' ? (
					<div className="columns">
						<div className="column is-3">
							<label className="label">ประเทศ</label>
							<Select name="selectedCountry" value={selectedCountry} clearable={false} onChange={this.onCountryChange} options={initCountries} />
						</div>
						<div className="column is-3">
							<label className="label">ประเภท VISA</label>
							<Select name="selectedVisaType" value={selectedVisaType} clearable={false} onChange={this.onVisaTypeChange} options={VISATYPES} />
						</div>
						<div className="column is-2">
							<InputRow
								title="จำนวนเล่ม"
								labelSize="s"
								placeholder="จำนวนเล่ม"
								keyProps="amount"
								type="number"
								value={fitVisa && fitVisa.amount}
								onInputChange={this.onVisaAmountChange}
								disabled={false}
							/>
						</div>
					</div>
				) : null}
				<div className="row">{this.renderFitItem()}</div>
				<div className="row">
					<TextArea title="Remark" labelSize="s" keyProps="note" value={note} onInputChange={this.onTextChange} row={4} />
				</div>
				{selectedFitType && selectedFitType.value !== 'fitTicket' ? (
					<div className="columns">
						<div className="column is-6">
							<AsyncSelect
								name="traveler"
								value={this.state.selectedTraveler}
								clearable={false}
								onChange={value => {
									this.setState({ selectedTraveler: value });
								}}
								defaultOptions={this.getDefaultTravelerOptions()}
								cacheOptions
								loadOptions={this.loadTravelerOptions}
								getOptionValue={option => option && (option.value != null ? option.value : option.id)}
								getOptionLabel={getTravelerLabel}
								loadingMessage={() => 'กำลังค้นหา...'}
								placeholder="ค้นหาจากชื่อ, เบอร์โทร, email"
								noOptionsMessage={() => 'ไม่มีข้อมูล Travel'}
							/>
						</div>
						<div className="column is-3">
							<button className="button is-success" onClick={() => this.addTraveler(this.state.selectedTraveler)}>
								เพิ่ม Traveler
							</button>
						</div>
					</div>
				) : null}
				{fitTravelersToRender.length > 0 ? this.renderTravelers(fitTravelersToRender) : null}
			</div>
		);
	}
}
